/**
 * Klab MMP People API
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { EmployeeHierarchyCreateRequest } from '../model/employeeHierarchyCreateRequest';
// @ts-ignore
import { EmployeeHierarchyUpdateRequest } from '../model/employeeHierarchyUpdateRequest';
// @ts-ignore
import { PagedEmployeeHierarchyResponse } from '../model/pagedEmployeeHierarchyResponse';
// @ts-ignore
import { PagedEmployeeByManagerResponse } from '../model/pagedEmployeeByManagerResponse';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';


@Injectable({
  providedIn: 'root'
})
export class EmployeeHierarchiesService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get employees by manager ID
     * @endpoint get /api/v1/employee-hierarchy/{managerId}
     * @param managerId Manager ID
     * @param page Page number (0-indexed)
     * @param size Number of items per page
     * @param locationId Filter assigned employees by location ID
     * @param departmentId Filter assigned employees by department ID
     * @param roleId Filter assigned employees by role ID
     */
    public getEmployeesByManagerId(managerId: number, page?: number, size?: number, locationId?: number, departmentId?: number, roleId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedEmployeeByManagerResponse>;
    public getEmployeesByManagerId(managerId: number, page?: number, size?: number, locationId?: number, departmentId?: number, roleId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedEmployeeByManagerResponse>>;
    public getEmployeesByManagerId(managerId: number, page?: number, size?: number, locationId?: number, departmentId?: number, roleId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedEmployeeByManagerResponse>>;
    public getEmployeesByManagerId(managerId: number, page?: number, size?: number, locationId?: number, departmentId?: number, roleId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (managerId === null || managerId === undefined) {
            throw new Error('Required parameter managerId was null or undefined when calling getEmployeesByManagerId.');
        }

        let localVarQueryParameters = new OpenApiHttpParams();
        if (page !== undefined && page !== null) {
            localVarQueryParameters = localVarQueryParameters.append('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            localVarQueryParameters = localVarQueryParameters.append('size', <any>size);
        }
        if (locationId !== undefined && locationId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('locationId', <any>locationId);
        }
        if (departmentId !== undefined && departmentId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('departmentId', <any>departmentId);
        }
        if (roleId !== undefined && roleId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('roleId', <any>roleId);
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/employee-hierarchy/${this.configuration.encodeParam({name: "managerId", value: managerId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedEmployeeByManagerResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all employee hierarchies with pagination and filtering
     * @endpoint get /api/v1/employee-hierarchies
     * @param page Page number (0-indexed)
     * @param size Number of items per page
     * @param locationId Filter by location ID
     * @param departmentId Filter by department ID
     * @param roleId Filter by role ID
     */
    public getAllEmployeeHierarchies(page?: number, size?: number, locationId?: number, departmentId?: number, roleId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedEmployeeHierarchyResponse>;
    public getAllEmployeeHierarchies(page?: number, size?: number, locationId?: number, departmentId?: number, roleId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedEmployeeHierarchyResponse>>;
    public getAllEmployeeHierarchies(page?: number, size?: number, locationId?: number, departmentId?: number, roleId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedEmployeeHierarchyResponse>>;
    public getAllEmployeeHierarchies(page?: number, size?: number, locationId?: number, departmentId?: number, roleId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        let localVarQueryParameters = new OpenApiHttpParams();
        if (page !== undefined && page !== null) {
            localVarQueryParameters = localVarQueryParameters.append('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            localVarQueryParameters = localVarQueryParameters.append('size', <any>size);
        }
        if (locationId !== undefined && locationId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('locationId', <any>locationId);
        }
        if (departmentId !== undefined && departmentId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('departmentId', <any>departmentId);
        }
        if (roleId !== undefined && roleId !== null) {
            localVarQueryParameters = localVarQueryParameters.append('roleId', <any>roleId);
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/employee-hierarchies`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedEmployeeHierarchyResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create employee hierarchy
     * @endpoint post /api/v1/employee-hierarchies
     * @param employeeHierarchyCreateRequest
     */
    public createEmployeeHierarchy(employeeHierarchyCreateRequest: EmployeeHierarchyCreateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public createEmployeeHierarchy(employeeHierarchyCreateRequest: EmployeeHierarchyCreateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public createEmployeeHierarchy(employeeHierarchyCreateRequest: EmployeeHierarchyCreateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public createEmployeeHierarchy(employeeHierarchyCreateRequest: EmployeeHierarchyCreateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (employeeHierarchyCreateRequest === null || employeeHierarchyCreateRequest === undefined) {
            throw new Error('Required parameter employeeHierarchyCreateRequest was null or undefined when calling createEmployeeHierarchy.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/employee-hierarchies`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: employeeHierarchyCreateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update employee hierarchy
     * @endpoint put /api/v1/employee-hierarchies/{employeeHierarchyId}
     * @param employeeHierarchyId Employee hierarchy ID
     * @param employeeHierarchyUpdateRequest
     */
    public updateEmployeeHierarchy(employeeHierarchyId: number, employeeHierarchyUpdateRequest: EmployeeHierarchyUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updateEmployeeHierarchy(employeeHierarchyId: number, employeeHierarchyUpdateRequest: EmployeeHierarchyUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updateEmployeeHierarchy(employeeHierarchyId: number, employeeHierarchyUpdateRequest: EmployeeHierarchyUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updateEmployeeHierarchy(employeeHierarchyId: number, employeeHierarchyUpdateRequest: EmployeeHierarchyUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (employeeHierarchyId === null || employeeHierarchyId === undefined) {
            throw new Error('Required parameter employeeHierarchyId was null or undefined when calling updateEmployeeHierarchy.');
        }
        if (employeeHierarchyUpdateRequest === null || employeeHierarchyUpdateRequest === undefined) {
            throw new Error('Required parameter employeeHierarchyUpdateRequest was null or undefined when calling updateEmployeeHierarchy.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/employee-hierarchies/${this.configuration.encodeParam({name: "employeeHierarchyId", value: employeeHierarchyId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: employeeHierarchyUpdateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete employee hierarchy
     * @endpoint delete /api/v1/employee-hierarchies/{employeeHierarchyId}
     * @param employeeHierarchyId Employee hierarchy ID
     */
    public deleteEmployeeHierarchyById(employeeHierarchyId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteEmployeeHierarchyById(employeeHierarchyId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteEmployeeHierarchyById(employeeHierarchyId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteEmployeeHierarchyById(employeeHierarchyId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (employeeHierarchyId === null || employeeHierarchyId === undefined) {
            throw new Error('Required parameter employeeHierarchyId was null or undefined when calling deleteEmployeeHierarchyById.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath = `/api/v1/employee-hierarchies/${this.configuration.encodeParam({name: "employeeHierarchyId", value: employeeHierarchyId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }
}
